import Logo from "./Logo"; // eslint-disable-line no-unused-vars

const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer className="bg-[#0A2A1E] text-[#FAF9F6] border-t border-[#FAF9F6]/10">
      {/* Giant wordmark */}
      <div className="px-5 lg:px-10 pt-16 pb-8">
        <div className="max-w-[1400px] mx-auto">
          <div
            className="font-display leading-[0.85] tracking-[-0.04em] text-[#FAF9F6] select-none"
            style={{ fontSize: "clamp(4rem, 18vw, 22rem)" }}
          >
            SconeCORE<span className="text-[#C6F035]">.</span>
          </div>
        </div>
      </div>

      <div className="border-t border-[#FAF9F6]/10 px-5 lg:px-10 py-10">
        <div className="max-w-[1400px] mx-auto grid grid-cols-1 md:grid-cols-12 gap-8 items-start">
          <div className="md:col-span-4 flex items-center">
            <img
              src="/products/logo-mark.png"
              alt="SconeCORE Enterprises"
              className="h-24 md:h-28 w-auto object-contain"
            />
          </div>

          <div className="md:col-span-3">
            <div className="overline text-[#FAF9F6]/50 mb-3">Navigate</div>
            <ul className="space-y-2">
              <li><a href="#manifesto" className="link-wipe">Ethos</a></li>
              <li><a href="#products" className="link-wipe">Products</a></li>
              <li><a href="#industries" className="link-wipe">Industries</a></li>
              <li><a href="#contact" className="link-wipe">Contact</a></li>
            </ul>
          </div>

          <div className="md:col-span-3">
            <div className="overline text-[#FAF9F6]/50 mb-3">Contact</div>
            <ul className="space-y-2 text-sm">
              <li>
                <a href="tel:+917296920646" className="link-wipe">
                  +91 72969 20646
                </a>{" "}
                <span className="text-[#FAF9F6]/40">/</span>{" "}
                <a href="tel:+916377429079" className="link-wipe">
                  +91 63774 29079
                </a>
              </li>
              <li>
                <a
                  href="mailto:sconecoreenterprises@gmail.com"
                  className="link-wipe break-all"
                >
                  sconecoreenterprises@gmail.com
                </a>
              </li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <div className="overline text-[#FAF9F6]/50 mb-3">Legal</div>
            <p className="text-xs text-[#FAF9F6]/50 leading-relaxed">
              © {year} SconeCORE Enterprises. All rights reserved. Proprietor:
              Arnav Malkani.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
